import { Typography } from '@mui/material'

const NumberBubble = ({ value, isOffline }: { value: string; isOffline: boolean }) => {
  const offlineText = isOffline ? ' (Offline)' : ''
  const ariaLabel = value || 'Unknown'

  return (
    <Typography variant="body1" color={isOffline ? 'divider' : 'textPrimary'} aria-label={`${ariaLabel}${offlineText}`}>
      {value || '--'}
    </Typography>
  )
}

export default NumberBubble
